.panel {
  flex: none;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-lg);
  padding: var(--spacing-sm) var(--spacing-md);
  border-top: 1px solid var(--color-border);
  background: var(--color-surface-sunken);
}

.title {
  flex: none;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-primary);
}

.metrics {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-xs) var(--spacing-xl);
  margin: 0;
}

.metric {
  display: flex;
  flex-direction: column;
  min-width: 84px;
}

.label {
  font-size: var(--font-size-xs);
  color: var(--color-text-muted);
  white-space: nowrap;
}

.value {
  margin: 0;
  font-family: var(--font-mono);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
}
